import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getCourseById } from '../api';
import './SkillDetail.css';
import linkedinLogo from '../linkedin.png'; 


const SkillDetail = () => {
  const { id } = useParams();
  const [skill, setSkill] = useState(null);
  const [loading, setLoading] = useState(true);

  // Link de tu comunidad (puedes cambiarlo por el real)
  const whatsappCommunityLink = "https://chat.whatsapp.com/FiIsFNaZeJQLFPGX3LI3Ls";

  useEffect(() => {
    const fetchSkill = async () => {
      try {
        const response = await getCourseById(id);
        setSkill(response.data);
      } catch (error) {
        console.error("Error cargando la habilidad:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchSkill();
  }, [id]);

  if (loading) return <div className="loading-msg">Cargando clase...</div>;
  if (!skill) return <div className="loading-msg">Clase no encontrada.</div>;

  return (
    <div className="skill-detail-container">
      
      {/* HEADER Y VIDEO */}
      <div className="skill-header">
        <span className="badge-free">Free Course</span>
        <h1>{skill.title}</h1>
        
        <div className="video-container">
           {skill.video_intro_url ? (
             <iframe 
               src={skill.video_intro_url} 
               title={skill.title} 
               frameBorder="0"
               allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
               allowFullScreen
             ></iframe>
           ) : (
             <div className="no-video">Video no disponible</div>
           )}
        </div>
      </div>

      {/* --- NUEVA SECCIÓN: DESCRIPCIÓN Y WHATSAPP --- */}
      <div className="skill-content-wrapper">
        
        {/* Descripción del Curso */}
        <div className="skill-description-box">
          <h2>Sobre esta clase</h2>
          <p>{skill.description || "En esta sesión aprenderás los fundamentos clave para aplicar esta tecnología en tus proyectos de minería y geología."}</p>
          
          <div className="skill-tags">
            <span><i className="fas fa-check-circle"></i> Acceso Gratuito</span>
            <span><i className="fas fa-clock"></i> A tu propio ritmo</span>
            <span><i className="fas fa-globe"></i> 100% Online</span>
          </div>
        </div>

        {/* Botón de Comunidad WhatsApp */}
        <div className="whatsapp-help-box">
          <div className="wsp-icon-large">
            <i className="fab fa-whatsapp"></i>
          </div>
          <h3>¿Preguntas de la clase?</h3>
          <p>Resuélvelas en tiempo real con otros profesionales.</p>
          <a 
            href={whatsappCommunityLink} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="btn-wsp-community"
          >
            Unirme a la Comunidad The Bull Miner
          </a>
        </div>

      </div>

      {/* STATS Y TESTIMONIOS */}
      <div className="skill-stats">
        <div className="rating-box">
          <span className="score">4.7</span>
          <div className="stars">★★★★★</div>
          <p>¿Qué tanto te fue útil el curso?</p>
          <small>Basado en 1633 ratings</small>
        </div>
        
        {/* SECCIÓN TESTIMONIOS */}
        <div className="testimonials-grid">
           {skill.testimonials && skill.testimonials.length > 0 ? (
             skill.testimonials.map(t => (
               <div className="testimonial-card-visual" key={t.id}>
                 <div className="testimonial-user-info">
                   <img 
                     src={t.student_photo_url || "https://via.placeholder.com/50"} 
                     alt={t.student_name} 
                     className="student-avatar"
                   />
                   <div className="user-details">
                     <strong>{t.student_name}</strong>
                     
                     {/* LINKEDIN MEJORADO */}
                     {t.linkedin_url && (
                       <div className="linkedin-wrapper">
                         <span className="linkedin-hint">Revisa su perfil profesional:</span>
                         <a href={t.linkedin_url} target="_blank" rel="noopener noreferrer" className="linkedin-btn-icon">
                           <img src={linkedinLogo} alt="LinkedIn" />
                         </a>
                       </div>
                     )}
                     
                   </div>
                 </div>
                 <p className="testimonial-text-visual">"{t.content}"</p>
               </div>
             ))
           ) : (
             // TESTIMONIO POR DEFECTO (Si no hay en BD)
             <div className="testimonial-card">
               <p>"Excelente introducción al tema."</p>
               <strong>- Estudiante de la comunidad</strong>
             </div>
           )}
        </div>
      </div>
    </div>
  );
};
export default SkillDetail;